import PropTypes from 'prop-types';
import React from 'react';

import { Tooltip } from '@commons/utils/styledLibraryComponents';

import { formatStoreNames, STORE_NAMES_VISIBLE_COUNT } from '../../utils/format';

import { StoreListText } from '../../styledComponents';

const StoreList = ({ storeNames }) => {
  if (!Array.isArray(storeNames) || storeNames.length === 0) {
    return null;
  }

  const { display, fullList } = formatStoreNames(storeNames);
  const hasOverflow = storeNames.length > STORE_NAMES_VISIBLE_COUNT;

  if (!hasOverflow) {
    return <StoreListText>{display}</StoreListText>;
  }

  return (
    <Tooltip
      renderTooltipTrigger={() => <StoreListText>{display}</StoreListText>}
      text={fullList}
      displayBigger
    />
  );
};

StoreList.propTypes = {
  storeNames: PropTypes.arrayOf(PropTypes.string),
};

StoreList.defaultProps = {
  storeNames: [],
};

export default StoreList;
